var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCopyiconBlue(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M2 2H12.1295L12.1295 12.1295H2L2 2ZM0 2C0 0.89543 0.89543 0 2 0H12.1295C13.2341 0 14.1295 0.895431 14.1295 2V3.87109H15.9987C17.1033 3.87109 17.9987 4.76652 17.9987 5.87109V16.0006C17.9987 17.1052 17.1033 18.0006 15.9987 18.0006H5.86914C4.76457 18.0006 3.86914 17.1052 3.86914 16.0006V14.1295H2C0.89543 14.1295 0 13.2341 0 12.1295V2ZM5.86914 14.1295V16.0006H15.9987L15.9987 5.87109H14.1295V12.1295C14.1295 13.2341 13.2341 14.1295 12.1295 14.1295H5.86914Z",
    fill: "#556BB8"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCopyiconBlue);
export default __webpack_public_path__ + "static/media/copyicon-blue.5b0127bbf14ddcff8226982d3db71bb1.svg";
export { ForwardRef as ReactComponent };